(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slurp-page-heading"] && !Shopify.designMode) return;
  try {
    
function initSlurpPurchaseReturn(){
const link=document.querySelector('.slurp-purchase-return');
const details=document.querySelector('.product-details');
const button=details?.querySelector('button[type="submit"]');
if(!link||!details||!button)return;
link.href='#'+details.id;
const observer=new IntersectionObserver(entries=>{
const entry=entries[0];
link.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;
},{threshold:0});
observer.observe(button);
}
initSlurpPurchaseReturn();
document.addEventListener('shopify:section:load',initSlurpPurchaseReturn);

  } catch(e) { console.error(e); }
})();
})();
